var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ptr-loading"}},[_c('div',{staticClass:"lds-ripple"},[_c('div'),_c('div'),_c('img',{staticClass:"logo-icon",attrs:{"id":"ptr-loading-icon","src":"/logo.svg","alt":"pointr-loading"}})])])
}]

export { render, staticRenderFns }